import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const getSurvey = async (params) => {
  const res = await axios.apiCadernoVirtual("/survey-service/research", {
    params,
  });
  return res.object[0];
};

export const useSurvey = ({
  config,
  surveyId,
  params = {
    studentId: _cookies.getItem("auth")?.user?.alunoid,
  },
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["survey", { surveyId, ...params }],
    queryFn: () => getSurvey({ id: surveyId, ...params }),
  });
};
